/* kic-newsletter-modal.js - Wave B comp 26-27 theme-port.
   Triggers: intent-leave (mouseleave from top, desktop) OR dwell (60s, after
   25% scroll). Suppression cookies gated on Termly consent state with
   sessionStorage fallback. ARIA dialog with focus trap.
   Forward-only per memory feedback_no_retroactive_bulk_email.md. */
(function () {
  'use strict';

  var modal = document.querySelector('[data-kic-nl-modal]');
  if (!modal) return;

  var dialog = modal.querySelector('[data-kic-nl-dialog]');
  var closeBtn = modal.querySelector('[data-kic-nl-close]');
  // R10.4 (2026-05-01) — `[data-kic-nl-form]` is the wrapper <div> around the
  // {% form 'customer' %} block (R9.6 introduced the wrapper because Liquid
  // form-tag arg whitelist may reject hyphenated keys). The native `submit`
  // event only fires on <form> elements, so the previous div binding never
  // recorded a successful subscribe. Descend into the inner <form>.
  var form = modal.querySelector('[data-kic-nl-form] form') || modal.querySelector('form');
  var settings = modal.dataset || {};

  var ENABLE_INTENT = settings.enableIntent !== 'false';
  var ENABLE_DWELL = settings.enableDwell !== 'false';
  var DWELL_SECONDS = parseInt(settings.dwellSeconds, 10) || 60;
  var COOLDOWN_SECONDS = parseInt(settings.cooldownSeconds, 10) || 60;
  var LOCK_AFTER = parseInt(settings.lockAfterDismissals, 10) || 3;
  var LOCK_DAYS = parseInt(settings.lockDays, 10) || 30;

  var COOKIE_DISMISSED_AT = 'kic_nl_dismissed_at';
  var COOKIE_DISMISS_COUNT = 'kic_nl_dismiss_count';
  var COOKIE_SUBSCRIBED = 'kic_nl_subscribed_at';

  var triggerEl = null;
  var dwellTimer = null;
  var scrolledDeep = false;
  var triggered = false;

  // -- Termly consent gating --------------------------------------------------
  function termlyConsent() {
    try {
      var t = window.Termly;
      if (t && typeof t.getConsentState === 'function') {
        var s = t.getConsentState();
        if (s && (s.statistics === true || s.functional === true)) return 'granted';
        return 'denied';
      }
    } catch (e) {}
    return 'unknown';
  }

  function setCookie(name, value, days) {
    if (termlyConsent() === 'denied') {
      // sessionStorage fallback ONLY
      try { window.sessionStorage.setItem(name, String(value)); } catch (e) {}
      return;
    }
    var expires = '';
    if (days) {
      var d = new Date();
      d.setTime(d.getTime() + days * 86400000);
      expires = '; expires=' + d.toUTCString();
    }
    try {
      document.cookie = encodeURIComponent(name) + '=' + encodeURIComponent(value) +
        expires + '; path=/; SameSite=Lax';
    } catch (e) {
      try { window.sessionStorage.setItem(name, String(value)); } catch (e2) {}
    }
  }

  function getCookie(name) {
    try {
      var sv = window.sessionStorage.getItem(name);
      if (sv != null) return sv;
    } catch (e) {}
    var match = document.cookie.match(
      new RegExp('(?:^|; )' + name.replace(/([.*+?^${}()|[\]\\])/g, '\\$1') + '=([^;]*)')
    );
    return match ? decodeURIComponent(match[1]) : null;
  }

  // -- Suppression check ------------------------------------------------------
  function isSuppressed() {
    if (getCookie(COOKIE_SUBSCRIBED)) return true;
    var count = parseInt(getCookie(COOKIE_DISMISS_COUNT) || '0', 10) || 0;
    if (count >= LOCK_AFTER) {
      var firstLockAt = parseInt(getCookie('kic_nl_lock_at') || '0', 10) || 0;
      if (firstLockAt && Date.now() - firstLockAt < LOCK_DAYS * 86400000) return true;
    }
    var dismissedAt = parseInt(getCookie(COOKIE_DISMISSED_AT) || '0', 10) || 0;
    if (dismissedAt && (Date.now() - dismissedAt) / 1000 < COOLDOWN_SECONDS) return true;
    return false;
  }

  // -- Focus trap -------------------------------------------------------------
  function getFocusable() {
    return dialog.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]),' +
      ' select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
  }

  function trapFocus(ev) {
    if (ev.key !== 'Tab') return;
    var focusable = getFocusable();
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (ev.shiftKey && document.activeElement === first) {
      ev.preventDefault();
      last.focus();
    } else if (!ev.shiftKey && document.activeElement === last) {
      ev.preventDefault();
      first.focus();
    }
  }

  function onKeydown(ev) {
    if (ev.key === 'Escape') { ev.preventDefault(); close(); return; }
    if (ev.key === 'Tab') trapFocus(ev);
  }

  // -- Open / close -----------------------------------------------------------
  function open(via) {
    if (triggered) return;
    if (isSuppressed()) return;
    triggered = true;
    triggerEl = document.activeElement;
    modal.setAttribute('data-open', 'true');
    document.documentElement.classList.add('kic-nl-modal-open');
    document.addEventListener('keydown', onKeydown);
    setTimeout(function () {
      if (closeBtn) closeBtn.focus();
    }, 30);
  }

  function close() {
    // R4.6: clear pending dwell timer so post-dismiss re-open never fires.
    if (dwellTimer) { clearTimeout(dwellTimer); dwellTimer = null; }
    modal.setAttribute('data-open', 'false');
    document.documentElement.classList.remove('kic-nl-modal-open');
    document.removeEventListener('keydown', onKeydown);
    var count = parseInt(getCookie(COOKIE_DISMISS_COUNT) || '0', 10) || 0;
    setCookie(COOKIE_DISMISS_COUNT, count + 1, 30);
    setCookie(COOKIE_DISMISSED_AT, Date.now(), 30);
    if (count + 1 >= LOCK_AFTER && !getCookie('kic_nl_lock_at')) {
      setCookie('kic_nl_lock_at', Date.now(), LOCK_DAYS);
    }
    if (triggerEl && typeof triggerEl.focus === 'function') {
      try { triggerEl.focus(); } catch (e) {}
    } else {
      try { document.body.focus(); } catch (e) {}
    }
  }

  // -- Triggers ---------------------------------------------------------------
  function setupIntentTrigger() {
    if (!ENABLE_INTENT) return;
    if (window.matchMedia && window.matchMedia('(max-width: 749px)').matches) return;
    document.documentElement.addEventListener('mouseleave', function (ev) {
      if (ev.clientY <= 1 && !triggered) open('intent');
    });
  }

  function setupDwellTrigger() {
    if (!ENABLE_DWELL) return;
    function onScroll() {
      if (scrolledDeep) return;
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      var docHeight = Math.max(
        document.documentElement.scrollHeight,
        document.body ? document.body.scrollHeight : 0
      );
      var winHeight = window.innerHeight || document.documentElement.clientHeight;
      var pct = scrollTop / Math.max(1, (docHeight - winHeight));
      if (pct >= 0.25) {
        scrolledDeep = true;
        window.removeEventListener('scroll', onScroll);
        dwellTimer = setTimeout(function () {
          if (!triggered) open('dwell');
        }, DWELL_SECONDS * 1000);
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // -- Wire-up ---------------------------------------------------------------
  if (closeBtn) closeBtn.addEventListener('click', close);
  modal.addEventListener('click', function (ev) {
    if (ev.target === modal) close();
  });

  if (form) {
    form.addEventListener('submit', function () {
      // Mark subscribed; Shopify form posts and reloads.
      setCookie(COOKIE_SUBSCRIBED, Date.now(), 365);
    });
  }

  setupIntentTrigger();
  setupDwellTrigger();

  // Expose for tests
  window.KIC = window.KIC || {};
  window.KIC.newsletterModal = {
    open: function () { triggered = false; open('manual'); },
    close: close,
    isSuppressed: isSuppressed
  };
})();
